
export default {
  name: 'modal-view-result',
  components: {},
  props: ['programmation'],
  data () {
    return {
      asset_base_url: ''
    }
  },
  watch:{
    programmation(){
      console.log(this.asset_base_url+this.programmation.fichier)
    }
  },
  computed: {

  },
  mounted () {
    this.asset_base_url = this.assets_path
  },
  methods: {

  }
}


